import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { initializeStore } from "./app-provider";
export const AppContext = React.createContext(null);
export const AppContextProvider = ({ children, }) => {
    const [app, setApp] = React.useState(initializeStore());
    return (_jsx(AppContext.Provider, { value: { app, setApp }, children: children }));
};
